import { requestJson } from "../../service/api";

/**
 * POST /invoice/:id/session — returns { ok, status, body } per pack §5.1
 * @param {number} invoiceId
 * @param {string|null} idempotencyKey
 * @param {{ confirmNew?: boolean }} [opts]
 */
const openPaymentSession = async (invoiceId, idempotencyKey, opts = {}) => {
  const config = idempotencyKey
    ? { headers: { "Idempotency-Key": String(idempotencyKey).slice(0, 100) } }
    : {};
  const body = { paymentMethodId: 1 };
  if (opts.confirmNew === true) body.confirmNew = true;
  return requestJson("post", `/invoice/${invoiceId}/session`, body, config);
};

export default openPaymentSession;
